import React, {useState} from "react";

import {ReviewChoice} from "@globals/DailyOrders/interfaces";

import Button from "@components/Button";
import LoadingDots from "@components/LoadingDots";
import {TextareaField} from "@components/forms";

import DishReviewChoices from "./DishReviewChoices";
import styles from "./DishReviewForm.scss";

type DishFullReviewProps = {
  hasComment: boolean;
  rating: number;
  selectedChoices: number[];
  setSelectedChoices: (selectedChoices: number[]) => void;
  availableChoices: ReviewChoice[];
  isChoicesLoading: boolean;
};

export default function DishFullReview({
  hasComment,
  rating,
  selectedChoices,
  setSelectedChoices,
  availableChoices,
  isChoicesLoading,
}: DishFullReviewProps): JSX.Element {
  const [showCommentForm, setShowCommentForm] = useState<boolean>(false);

  // show comment field when: user clicked on the "other" choice, or there is a comment, or there is no choices;
  const showComment =
    (showCommentForm || hasComment || availableChoices.length === 0) &&
    !isChoicesLoading;
  return (
    <>
      <h4 className={styles.choicesTitle}>
        {rating === 5 ? "What did you enjoy?" : "What needs to be improved?"}
      </h4>

      {isChoicesLoading && (
        <div className={styles.choicesLoader}>
          <LoadingDots />
        </div>
      )}
      {!!availableChoices.length && (
        <DishReviewChoices
          availableChoices={availableChoices}
          selectedChoices={selectedChoices}
          setSelectedChoices={setSelectedChoices}
          showComment={showComment}
          setShowCommentForm={setShowCommentForm}
        />
      )}

      {showComment && (
        <TextareaField
          className={styles.commentField}
          name="comment"
          rows={5}
          placeholder="Add comments..."
        />
      )}

      <Button type="submit" className={styles.submitReviewButton}>
        Submit
      </Button>
    </>
  );
}
